
document.addEventListener("DOMContentLoaded", function () {
  const SLIDER_POSITION_KEY = "testimonial_slider_position";
  let initialIndex = localStorage.getItem(SLIDER_POSITION_KEY)
    ? parseInt(localStorage.getItem(SLIDER_POSITION_KEY))
    : 0;

  const realSlides = Array.from(document.querySelectorAll('.testimonials-app .swiper-slide:not(.swiper-slide-duplicate)'));
  const totalSlides = realSlides.length;

  const swiperBottom = new Swiper(".testimonials-app", {
    slidesPerView: "auto",
    centeredSlides: true,
    rtl: true,
    loop: true,
    spaceBetween: 9,
    speed: 1200,
    effect: 'slide',
    grabCursor: true,
    watchSlidesProgress: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      320: { speed: 1000 },
      768: { speed: 1200 },
      1024: { speed: 1400 }
    },
    on: {
      slideChange: function () {
        localStorage.setItem(SLIDER_POSITION_KEY, this.realIndex);
      },
      slideChangeTransitionStart: function () {
        this.slides.forEach(slide => {
          slide.style.transition = 'transform 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.8s ease';
        });
      },
      slideChangeTransitionEnd: function () {
        this.slides.forEach(slide => {
          slide.style.transition = '';
        });
      }
    }
  });

  // Forzar que empiece en el slide real
  swiperBottom.slideToLoop(initialIndex, 0, false);

  const swiperReverse = new Swiper(".swiper-reverse", {
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    spaceBetween: 9,
    speed: 1200,
    effect: 'slide',
    grabCursor: true,
    watchSlidesProgress: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      320: { speed: 1000 },
      768: { speed: 1200 },
      1024: { speed: 1400 }
    },
    on: {
      slideChangeTransitionStart: function () {
        this.slides.forEach(slide => {
          slide.style.transition = 'transform 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.8s ease';
        });
      },
      slideChangeTransitionEnd: function () {
        this.slides.forEach(slide => {
          slide.style.transition = '';
        });
      }
    }
  });

  const autoplayInterval = 5000;
  const STORAGE_KEY = "seenBottomTestimonials";
  let seenIndexes = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

  function getNextUnseenIndex() {
    for (let i = 0; i < totalSlides; i++) {
      if (!seenIndexes.includes(i)) return i;
    }
    seenIndexes = [];
    return 0;
  }

  function goToNext() {
    const nextIndex = getNextUnseenIndex();
    swiperBottom.slideToLoop(nextIndex, 500, false);
    swiperReverse.slideToLoop((totalSlides - nextIndex) % totalSlides, 500, false);
    if (!seenIndexes.includes(nextIndex)) {
      seenIndexes.push(nextIndex);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(seenIndexes));
    }
  }

  goToNext();
  setInterval(goToNext, autoplayInterval);
});

